export default __webpack_public_path__ + "static/The Home_Image 7_carousel 1@2x-db177d6ecf976b7b00231e8d6ceb053a.jpg";